import { useState } from "react";

import "./terms-and-conditions.css"; // import the CSS file
import Maincard from "../../comman/maincard";
import SEO from "../../comman/SEO";

const TermsAndConditionsPage = () => {
    <SEO
        title="Vaikunta Maha Ruchulu - Pure Veg Andhra Restaurant in Vizag  Terms and conditions"
        description="Review the terms of service for Vaikunta Maha Ruchulu's website, including policies on online ordering, payments, and catering services."
        keywords="website terms and conditions, terms of service, use of website, user obligations, limitation of liability, disclaimer of warranties, intellectual property rights, copyright, trademarks, governing law, online ordering policy, takeaway terms, delivery terms and conditions, payment methods, pricing policy, order cancellation policy, refund policy, catering terms and conditions, pure veg catering policy, catering order confirmation, catering cancellation fee, catering deposit, payment for catering services, user account terms, account creation, user responsibility, account termination, acceptable use policy"

        url="https://vaikuntamaharuchulu.com/"

    />

    const termsAndConditions = [
        {
            question: "Acceptance of Terms",
            answer: [
                "By accessing and using the Vaikunta Maha Ruchulu website (“Site”) or services, visitors and users (“you”) accept these terms and conditions in full. If you disagree with any part, please do not use the website or services."
            ],
        },
        {
            question: "Services and Information",
            answer: [
                "Vaikunta Maha Ruchulu offers restaurant details, menu, ordering, booking, and related content for informational and ordering purposes only. While we strive for accuracy, we do not guarantee all information is current or free from errors, and menu/prices may change without notice."
            ],
        },
        {
            question: "Orders and Payment",
            answer: [
                "All online and phone orders are subject to availability, confirmation, and timely payment. We reserve the right to refuse or cancel any order for reasons including menu item unavailability, payment issues, or suspected misuse."
            ],
        },
        {
            question: "Intellectual Property",
            answer: [
                "The Site’s content, logo, branding, images, and menu are the intellectual property of Vaikunta Maha Ruchulu. You may not reproduce, copy, or modify any materials without written permission, except for personal, non-commercial use."
            ],
        },
        {
            question: "User Conduct",
            answer: [
                "Users agree not to misuse the website or engage in illegal, fraudulent, or disruptive behavior. Posting offensive, defamatory, or harmful content is strictly prohibited."
            ],
        },
        {
            question: "Privacy Policy",
            answer: [
                "User data submitted via forms (contact, reservation, online order) is collected for service and communication purposes. We do not share your personal information with third parties except if required by law or for service fulfillment. See our Privacy Policy for details."
            ],
        },
        {
            question: "Limitation of Liability",
            answer: [
                "Vaikunta Maha Ruchulu is not liable for any direct, indirect, or incidental damages arising from the use of the site, reliance on content, or ordering errors. All service and menu information is provided “as is”."
            ],
        },
        {
            question: "Links to Other Sites",
            answer: [
                "The website may contain links to third-party sites. We are not responsible for the content or accuracy of third-party sites linked from our service."
            ],
        },
        {
            question: "Changes to Terms",
            answer: [
                "We may update or change these terms at any time without advance notice. Your continued use of the site implies acceptance of the revised terms."
            ],
        },
        {
            question: "Contact Information",
            answer: [
                "For queries, feedback, or concerns about these Terms, please contact the restaurant directly via our Contact Us page or call 7900368003."
            ],
        }
    ]
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            <SEO
                title="Vaikunta Maha Ruchulu - Pure Veg Andhra Restaurant in Vizag  Terms and conditions"
                description="Review the terms of service for Vaikunta Maha Ruchulu's website, including policies on online ordering, payments, and catering services."
                keywords="Vaikunta Maha Ruchulu terms and conditions,
Pure veg restaurant policies Vizag,
Terms of service Vaikunta Maha Ruchulu,
Restaurant guidelines, Visakhapatnam,
Vizag dining terms of use,
Legal policies for Vaikunta Maha Ruchulu pure vegetarian restaurant,
Terms of use for Vizag authentic Andhra dining website,
User agreement for Visakhapatnam vegetarian catering and dining,
Service and privacy guidelines for Vizag restaurant,
What are the terms and conditions for Vaikunta Maha Ruchulu's website and services?,
Vaikunta Maha Ruchulu reservation and cancellation policy,
Vaikunta Maha Ruchulu website policies,
Visakhapatnam veg restaurant rules and regulations"   />
            <div>
                <Maincard
                    image={"assets/terms_conditions.jpg"}
                    title={"TERMS AND CONDITIONS"}
                />
            </div>

            <div className="faq-container">
                <h1 className="faq-title">Vaikunta Maha Ruchulu – Terms and Conditions</h1>
                <div className="faq-list">
                    {termsAndConditions.map((items, index) => (
                        <div key={index} className="faq-item">
                            <button
                                className="faq-question"
                                onClick={() => toggleFAQ(index)}
                            >
                                <span>{items.question}</span>
                                <span className="faq-icon">{openIndex === index ? "−" : "+"}</span>
                            </button>
                            {openIndex === index && (
                                <div className="faq-answer">
                                    {items.answer.map((item, idx) => (
                                        <p key={idx}>{item}</p>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default TermsAndConditionsPage;
